<template>
    <text-hero-section
        class="text-hero-section-module"
        :title="attributes.textHero_title"
        :text="attributes.textHero_text"
    />
</template>

<script>
    import TextHeroSection from '../../../organisms/TextHeroSection/TextHeroSection';

    export default {
        name: 'text-hero-section-module',

        components: { TextHeroSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },
    };
</script>
